import { UTCDate } from '@date-fns/utc';
export const sectionHasValue = (data) => {
    const hasValue = (value) => {
        if (Array.isArray(value)) {
            return !!value.length;
        }
        if (value instanceof Date) {
            return true;
        }
        if (value && typeof value === 'object') {
            return Object.values(value).some(hasValue);
        }
        return !!value;
    };
    return hasValue(data);
};
export function combineDateTime(dateStr, timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const [year, month, day] = dateStr.split('-').map(Number);
    return new UTCDate(year, month - 1, day, hours, minutes);
}
